import {Tabs} from "antd";
import {NewReturn} from "./NewReturn";
import {ExistingReturn} from "./ExistingReturn";
import {useState} from 'react';

export const ReturnTab = ({refresh, onRefresh, onApiFail, props}) => {
    const [refreshReturn, onRefreshReturn] = useState(0);

    const items = [
        {
            key: 'NewReturn',
            label: 'New Return',
            children: <NewReturn refresh={refresh} onRefresh={onRefresh} onRefreshReturn={onRefreshReturn} onApiFail={onApiFail}/>
        },
        {
            key: 'ExistingReturn',
            label: 'Existing Return',
            children: <ExistingReturn  refresh={refreshReturn} onRefresh={onRefreshReturn} onApiFail={onApiFail}/>
        },
    ]

    return <Tabs tabPosition={'left'} defaultActiveKey={'NewReturn'} items={items} />
}